// import { gallery } from './data';

export default class CarouselGallery {
  images!: { link: string; title: string }[];

  carouselContainerEl!: HTMLElement;

  bigImgEl: HTMLImageElement | null = null;

  mapLinks: HTMLAnchorElement[][] = [];

  imgDescEl: HTMLElement | null = null;

  imagesElements: HTMLImageElement[] = [];

  imageActive!: HTMLImageElement;

  isChanging = false;

  constructor() {
    this.init();
  }

  init = () => {
    this.bigImgEl = document.querySelector('[data-gallery-img-big]');

    this.imgDescEl = (this.bigImgEl?.nextElementSibling?.nextElementSibling?.nextElementSibling as HTMLElement) ?? null;
    this.imagesElements = Array.from(
      document.querySelectorAll('[data-gallery-carousel] [data-gallery-img-id]'),
    ) as HTMLImageElement[];
    this.images = this.imagesElements.map((element) => ({
      link: element.src,
      title: element.alt,
    }));
    this.carouselContainerEl = this.imagesElements[0].parentElement?.parentElement as HTMLElement;
    this.imageActive = this.imagesElements[0].parentElement as HTMLImageElement;
  };

  bindEvents = () => {
    if (this.bigImgEl?.complete) this.removeSpinner();
    this.bigImgEl?.addEventListener('load', () => {
      this.bigImgEl?.nextElementSibling?.classList.remove('loading');
      this.bigImgEl?.nextElementSibling?.nextElementSibling?.classList.remove('loading');
    });
    this.imagesElements.forEach((element) => {
      if (element.complete) this.removeSpinner(element);
      element?.addEventListener('load', () => {
        element.nextElementSibling?.classList.remove('loading');
      });
      element?.addEventListener('click', (e) => {
        e.preventDefault();
        const target = e.target as HTMLImageElement;
        this.imageActive.classList.remove('active');
        this.imageActive = target.parentElement as HTMLImageElement;
        this.imageActive.classList.add('active');
        this.changeBigImg(Number(target.dataset.galleryImgId));
      });
    });
  };

  removeSpinner = (element: HTMLImageElement | null = null) => {
    if (!element) {
      this.bigImgEl?.nextElementSibling?.classList.remove('loading');
      this.bigImgEl?.nextElementSibling?.nextElementSibling?.classList.remove('loading');
    } else {
      element.nextElementSibling?.classList.remove('loading');
    }
  };

  changeBigImg = (id: number) => {
    if (this.isChanging) return;
    this.isChanging = true;
    this.bigImgEl!.classList.add('fade-out');
    this.imgDescEl!.classList.add('fade-out');

    setTimeout(() => {
      this.bigImgEl!.src = this.images[id].link;
      this.bigImgEl!.alt = this.images[id].title;
      this.imgDescEl!.innerText = this.images[id].title;
      this.isChanging = false;
      this.bigImgEl!.classList.remove('fade-out');
      this.imgDescEl!.classList.remove('fade-out');
    }, 100);
  };

  run = () => {
    this.bindEvents();
  };
}
